module.exports = __webpack_public_path__ + "img/sun.b1456bfb.jpg";